// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantBoardCard-moduleRentalPortalApplicantBoardCard__gxbW4";
var _2 = "RentalPortalApplicantBoardCard-moduleclickable__NZVqB";
var _3 = "RentalPortalApplicantBoardCard-modulefit__tjF0X RentalPortalMatchCriteriaPopover-moduletrigger__fNR9N";
var _4 = "RentalPortalApplicantBoardCard-modulehead__p6K_n";
var _5 = "RentalPortalApplicantBoardCard-moduleheadActions__xFnGH";
var _6 = "RentalPortalApplicantBoardCard-moduleidentity__C4HOi";
var _7 = "RentalPortalApplicantBoardCard-moduleidentityRow__M12sT";
var _8 = "RentalPortalApplicantBoardCard-modulemarker__s16D3";
var _9 = "RentalPortalApplicantBoardCard-modulemeta__y47RO";
var _a = "RentalPortalApplicantBoardCard-moduleneedsYou__KIJgI";
var _b = "RentalPortalApplicantBoardCard-moduleselectLabel__iovvN";
var _c = "RentalPortalApplicantBoardCard-modulesignals__nrxdP";
export { _1 as "RentalPortalApplicantBoardCard", _2 as "clickable", _3 as "fit", _4 as "head", _5 as "headActions", _6 as "identity", _7 as "identityRow", _8 as "marker", _9 as "meta", _a as "needsYou", _b as "selectLabel", _c as "signals" }
